'use client';
import { jsx } from 'react/jsx-runtime';
import { useSwanPopover } from './popover.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, o) {
    return r in e ? Object.defineProperty(e, r, {
        value: o,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = o, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var o = null != arguments[r] ? arguments[r] : {}, t = Object.keys(o);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
        }))), t.forEach(function(r) {
            _define_property(e, r, o[r]);
        });
    }
    return e;
}
const PopoverCloser = renderWithRef('PopoverCloser', null, (o, n)=>{
    let { overlayState: c } = useSwanPopover();
    return jsx(RenderComp, {
        root: "div",
        classNames: [
            'swan-popover-close'
        ],
        forwardedRef: n,
        props: _object_spread({}, o, {
            onClick: ()=>{
                c.close();
            }
        }),
        children: o.children
    });
});

export { PopoverCloser };
